module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLight.bd668a69.eot";